<template>
	<el-dialog
		title="解压密码"
		:visible.sync="showPressDialog"
		:close-on-click-modal="false"
		width="408px"
		class="press_box"
		@close="closed"
		 append-to-body
	>
		<div class="content">
			<div class="input_box">
				<input v-model.trim="pressPwd" placeholder="请输入解压密码" :type="showIcon?'password':'text'" @keyup.enter="pressSubmit" />
				<img :src="imgAllPath(showIcon?'close.png':'open.png')" @click="showIcon=!showIcon" />
			</div>
			<p class="press_p">{{status?'密码错误！':''}}</p>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="pressSubmit" size="mini" class="mini_btn" :disabled="!pressPwd" :loading="loading">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
        status:{//true密码错误
            type: Boolean,
			default:true
        },
		modalShow: {
			type: Boolean,
			default: false
        },
        loading:{
            type: Boolean,
			default: false
        }
	},
	data() {
		return {
			pressPwd: "",
            showIcon: true,
		};
	},
	watch:{
		pressPwd(n,o){
			this.$emit("changePwd", n);
		}
	},
	computed: {
		imgAllPath() {
			return function(img) {
				return require("@comm/images/document-conversion/onlinePreview/" + img);
			};
		},
		showPressDialog: {
			get() {
				return this.modalShow;
			},
			set() {}
		}
	},
	methods: {
		pressSubmit() {
			this.$emit("getResult", this.pressPwd);
		},
		closed() {
			this.pressPwd='';
			this.showIcon=true;
			this.$emit("closeModal");
		}
	}
};
</script>

<style lang="scss" scoped>
// 解压
.press_box {
	.content {
		.press_p {
			font-size: 12px;
			color: #e02020;
			height: 20px;
			margin-top: 8px;
		}
		.input_box {
			width: 360px;
			height: 30px;
			display: flex;
			align-items: center;
			border: 1px solid #dadada;
			margin-top:24px;
			input {
				flex: 1;
				border: 0 !important;
				height: 28px;
				border-radius: 0;
				text-indent: 5px;
			}
		}
		img {
			width: 20px;
			height: 20px;
			margin-right: 5px;
			cursor: pointer;
		}
	}
	.mini{
		width: 72px!important;
		height: 30px!important;
	}
}
</style>


// WEBPACK FOOTER //
// src/comm/components/document-conversion/pressDialog/index.vue